import React from "react";

import { afiPickupScheduleService } from "../jwt/_services/hotel/afiPickupScheduleService";

export const afiPickupScheduleProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await afiPickupScheduleService.getOptions( customFilter );
        listItems.data.sort((a, b) => a.title.localeCompare(b.title));

        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <label>{ item.title }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}